import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import UserGroupTableService from '../service/UserGroupTableService';

const config = {
	key: 'userGroupTable',
	text: 'Felhasználói csoport',
	topic: 'userGroup',
	service: UserGroupTableService,
	editFormState: item => `/user-group/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'name',
			text: 'Név',
			type: 'text'
		}
	]
};

function UserGroupTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('userGroupTable', reducer('userGroupTable'))(UserGroupTable);